<template>
  <layout-basic>
    <section class="banner-text">
      <v-container class="price-wrapper">
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="6">
            <div class="price-banner">
              AFFORDABLE PLANS
            </div>
            <h1>Plans and Pricing</h1>
            <p>
              Our price plans are based on the size of your business, our
              future-proof solution scales effortlessly as your organisation
              grows too.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <div class="pricing-images">
              <img
                class="yellow-jumper-man"
                src="/static/pricing/character-in-yellow-jumper.png"
                alt="Man in yellow jumper"
              />
              <img
                class="screen-1"
                src="/static/pricing/improve-advanced-reporting-stylised-screenshot.png"
                alt="Advanced Reporting Screenshot"
              />
              <img
                class="screen-2"
                src="/static/pricing/improve-create-groups-stylised-screenshot.png"
                alt="Create Groups Screenshot"
              />
              <img
                class="screen-3"
                src="/static/pricing/improve-user-friendly-interface-stylised-screenshot.png"
                alt="User-Friendly Interface Screenshot"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container>
        <div class="price-business-wrapper text-center">
            <h1>Choose the Best Plan for your Business</h1>
            <p>No obligation or credit card details needed to get started.</p>
        </div>
        <div class="pricing-tables">
          <!-- Desktop / Tablet Layout -->
          <div class="table-wrapper desktop-table">
            <!-- Header Row -->
            <div class="header-row">
              <div class="header-empty-cell"></div>
              <!-- Empty cell in the top-left corner -->
              <div
                v-for="(plan, index) in plans"
                :key="index"
                class="header-plan-cell"
              >
                <h3>{{ plan.users }}</h3>
                <h2>{{ plan.price }}<span>*</span></h2>
                <p>{{ plan.description }}</p>
                <a :href="directUrl + '/#/signup?ref=website'" class="free-trial-btn">Free Trial</a>
              </div>
            </div>

            <!-- Features Rows -->
            <div
              v-for="(feature, index) in features"
              :key="index"
              class="feature-row"
            >
              <div class="feature-name-cell">{{ feature.name }}</div>
              <div
                v-for="(plan, planIndex) in plans"
                :key="planIndex"
                class="feature-value-cell"
              >
                <span
                  v-if="feature.values[planIndex] === true"
                  class="check-icon"
                  >✔</span
                >
                <span
                  v-else-if="feature.values[planIndex] === false"
                  class="dash-icon"
                  >-</span
                >
                <span v-else>{{ feature.values[planIndex] }}</span>
              </div>
            </div>
          </div>

          <!-- Mobile Layout -->
          <div class="mobile-table">
            <div
              v-for="(plan, index) in plans"
              :key="index"
              class="pricing-plan-card"
            >
              <div class="plan-header">
                <h3>{{ plan.users }}</h3>
                <h2>{{ plan.price }}<span>*</span></h2>
                <p>{{ plan.description }}</p>
                <a :href="directUrl+'/#/signup?ref=website'" class="free-trial-btn">Free Trial</a>
              </div>
              <ul class="features-list">
                <li
                  v-for="(feature, featureIndex) in features"
                  :key="featureIndex"
                >
                  <span>{{ feature.name }}:</span>
                  <span v-if="feature.values[index] === true" class="check-icon"
                    >✔</span
                  >
                  <span
                    v-else-if="feature.values[index] === false"
                    class="dash-icon"
                    >-</span
                  >
                  <span v-else>{{ feature.values[index] }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p class="vat-text">*All prices exclusive of VAT.</p>
      </v-container>
    </section>
    <section>
        <div class="price-quote-wrapper">
            <h1>250+ Users in Your Business?</h1>
            <p>Request a bespoke quote from our team.</p>
            <a href="/contact" class="book-demo-btn" style="max-width: 200px;">
                Request a Quote
            </a>
        </div>
    </section>
    <section style="margin-bottom: 80px;">
      <v-row no-gutters>
        <v-col cols="12" align-self="center">
          <v-container>
            <div class="testimonial-title text-center">
              <img
                src="/static/homepage/testimonial/improve-customer-testimonials.png"
              />

              <h2>Customer Testimonials</h2>

              <p>
                What our customers say about IMPROVE
              </p>
            </div>
          </v-container>
        </v-col>
      </v-row>
      <v-container>
        <VueSlickCarousel v-bind="testimonialCarousel">
          <div class="testimonial-item">
            <div class="testimonial-card">
              <div>
                <h2>“Flexible and Limitless”</h2>
                <p>
                  “The system is like no other in the market. HRCentral Limited 
                  and our clients are continually impressed by the user-friendly, 
                  flexible and limitless training opportunities IMPROVE can offer.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“The Best Onboarding Process”</h2>
                <p>
                  “New staff have been in ‘awe’ of our onboarding process which
                  is all centrally delivered via IMPROVE. We have found it to be
                  the best onboarding process we have experienced.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/advocacy-focus-testimonial.png"
                alt="Advocacy Focus Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Comprehensive & Easy to Access”</h2>
                <p>
                  “It’s authoritative, accurate, comprehensive, and easy to
                  access. It removes the stress of training delivery from
                  business owners, knowing that they can review what their staff
                  are learning.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/smart-space-testimonial.png"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <div class="testimonial-card">
              <div>
                <h2>“Consistently Impressed”</h2>
                <p>
                  “As a proud partner of IMPROVE, we have been consistently impressed with the 
                  customer service and support we have received from the team. They are responsive, 
                  go out of their way to help, and adapt to support our needs and growth as a HR 
                  consultancy, which in turn supports our clients.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                alt="Smart Space Approved IMPROVE partner"
              />
            </div>
          </div>
          <div class="testimonial-item">
            <!-- <img
              src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
              class="testimonial-placeholder-circle"
            /> -->
            <div class="testimonial-card">
              <div>
                <h2>“Seamless Training Process”</h2>
                <p>
                  “The user-friendly interface has been built to ensure that
                  everyone can use it with ease, and the courses are tailored to
                  suit each team member's learning needs.”
                </p>
              </div>
              <img
                src="/static/homepage/testimonial/eden-holistic-pet-foods-testimonial.png"
                alt="Eden Holistic Pet Foods Approved IMPROVE partner"
              />
            </div>
          </div>
        </VueSlickCarousel>
      </v-container>
    </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import { IMPROVE_CONFIG } from "@/config.js";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  data() {
    return {
      directUrl: IMPROVE_CONFIG.DIRECT_URL,
      testimonialCarousel: {
        infinite: true,
        autoplay: true,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      plans: [
        { users: '1-50 USERS', price: '£995', description: 'Per business' },
        { users: '51-100 USERS', price: '£1,695', description: 'Per business' },
        { users: '101-250 USERS', price: '£2,995', description: 'Per business' },
      ],
      features: [
        {
          name: 'Unlimited access to all courses',
          values: [true, true, true],
        },
        {
          name: 'Upload and launch your own courses',
          values: [true, true, true],
        },
        {
          name: 'HR integration with current partners',
          values: [true, true, true],
        },
        { name: 'Personalised certificates', values: [true, true, true] },
        {
          name: 'Online support via email to real people',
          values: [true, true, true],
        },
        {
          name: 'Upgrade to more users at any time',
          values: [true, true, true],
        },
        {
          name: 'Weekly full platform report email',
          values: [false, true, true],
        },
        {
          name: 'IMPROVE Launch Programme (One off Cost)',
          values: ['£695', '£695', '£695'],
        },
        {
          name: 'Bolt-On Leadership Plus (50+ Interactive Modules)',
          values: ['£1,995', '£2,995', '£3,995'],
        },
      ],
    };
  },
  name: 'Pricing',
  metaInfo() {
    return {
      title: "IMPROVE: Flexible Annual Pricing Plans for SMEs | Free 14-Day Trial",
      meta: [
          // Meta Description
          { name: 'description', content: "Discover IMPROVE's simple and scalable pricing plans tailored for SMEs. Annual subscriptions start at just £995 per year. Enjoy unlimited access and a FREE 14-day trial!" },
          
          // Keywords
          { name: 'keywords', content: "IMPROVE pricing plans, SME online learning, affordable LMS pricing, subscription plans for training, scalable pricing, staff training costs, free LMS trial, annual training plans" },
         
          // Open Graph / Facebook Tags
          { property: 'og:title', content: "IMPROVE: Flexible Annual Pricing Plans for SMEs | Free 14-Day Trial" },
          { property: 'og:description', content: "Explore IMPROVE's cost-effective annual subscription plans for SMEs. Flat pricing starts at just £995 per year, with unlimited training access and a FREE 14-day trial." },
          { property: 'og:image', content: "https://www.improve.online/static/seo.png" },
          { property: 'og:type', content: "website" },
          { property: 'og:url', content: "https://www.improve.online/pricing" },
          
          // Twitter Card Tags
          { name: 'twitter:card', content: "summary_large_image" },
          { name: 'twitter:title', content: "IMPROVE: Flexible Annual Pricing Plans for SMEs | Free 14-Day Trial" },
          { name: 'twitter:description', content: "Flexible and affordable annual pricing for SMEs. Starting at £995 per year with unlimited course access. Try IMPROVE free for 14 days—no credit card required!" },
          { name: 'twitter:image', content: "https://www.improve.online/static/seo.png" }
      ],
      link: [
          { rel: 'canonical', href: "https://www.improve.online/pricing" }
      ]
    };
  },
  components: {
    LayoutBasic,
    VueSlickCarousel,
  },
  mounted: function() {},
  methods: {},
};
</script>

<style>
.price-wrapper {
  display: flex;
  align-items: center;
  height: 525px;
}

.price-banner {
  width: 234px;
  height: 20px;
  background-color: #6bc091;
  color: #122034;
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  margin-bottom: 20px;
}

p.vat-text {
    margin: 10px;
    text-align: center;
}

.price-wrapper h1 {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 20px;
}

.price-wrapper p {
  font-size: 18px;
  color: #122034;
  font-weight: 400;
  max-width: 485px;
}

.pricing-images {
  position: relative;
  height: 100%;
}

.yellow-jumper-man,
.screen-1,
.screen-2,
.screen-3 {
  position: absolute;
}

img.yellow-jumper-man {
  top: -62px;
  right: 40%;
}

img.screen-1 {
  left: -17%;
  top: 132px;
}

img.screen-2 {
  right: 10%;
}

img.screen-3 {
  left: -8%;
  top: -79px;
}

@media screen and (max-width: 959px) {
  .price-wrapper {
    flex-direction: column;
    height: 453px;
  }

  .price-banner {
    display: none;
  }

  .price-wrapper {
    text-align: center;
    padding-top: 50px;
  }

  .price-wrapper h1 {
    font-size: 1.5rem;
  }

  .price-wrapper p {
    font-size: 1rem;
    max-width: 579px;
  }

  img.yellow-jumper-man {
    width: 177px;
    top: -90px;
  }

  img.screen-1,
  img.screen-2,
  img.screen-3 {
    width: 85px;
  }

  img.screen-1 {
    left: -3%;
    top: 68px;
  }

  img.screen-2 {
    top: -25px;
    right: 17px;
  }

  img.screen-3 {
    left: 7%;
    top: -91px;
  }
}

@media screen and (max-width: 500px) {
  .price-wrapper {
    flex-direction: column;
    height: 400px;
    padding-top: 10px;
  }

  img.yellow-jumper-man {
    width: 140px;
    top: -76px;
    right: 32%;
  }

  img.screen-1 {
    width: 65px;
    left: 4%;
    top: 39px;
  }

  img.screen-2 {
    width: 65px;
    top: -25px;
    right: 17px;
  }

  img.screen-3 {
    width: 65px;
    left: 10%;
    top: -79px;
  }
}

.table-wrapper {
  display: grid;
  grid-template-columns: 1fr repeat(3, 1fr); /* 1 column for features, 3 columns for plans */
  gap: 1px;
  background-color: #ddd; /* Grid gap color */
}

.desktop-table {
  display: grid;
}

.header-row {
  display: contents; /* Makes rows line up with grid */
}

.header-empty-cell {
  background: #ffffff;
}

.header-plan-cell {
  background: white;
  text-align: center;
  padding: 30px 15px;
  border-top: 1px solid #ddd;;
}

.plan-header h3,
.header-plan-cell h3 {
    font-size: 16px;
    font-weight: 700;
    color: #333333;
}

.plan-header h2 span,
.header-plan-cell h2 span {
    position: absolute;
}

.plan-header h2,
.header-plan-cell h2 {
    font-size: 35px;
    font-weight: 700;
    color: #67BD95;
}

.plan-header p,
.header-plan-cell p {
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}

.feature-row {
  display: contents; /* Align features with grid columns */
}

.feature-name-cell {
  background: #f9f9f9;
  font-weight: bold;
  padding: 15px;
  border-left: 1px solid #ddd; /* Add border to the first cell */
}
 
.feature-value-cell {
  background: white;
  text-align: center;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-value-cell span {
    font-weight: 700;
    font-size: 16px;
    color: #67BD95;
}

/* Add border-bottom to the last row */
.feature-row:last-child .feature-name-cell,
.feature-row:last-child .feature-value-cell {
  border-bottom: 1px solid #ddd; /* Add bottom border to the last row */
}

.header-plan-cell:last-child,
.feature-value-cell:last-child {
  border-right: 1px solid #ddd; /* Add border to the last cell */
}

.check-icon {
  color: green;
  font-size: 1.2em;
}

.dash-icon {
  color: #666666 !important;
  font-size: 1.2em;
}

.free-trial-btn {
  background-color: #6BC091;
  border: 2px solid #6BC091 !important;
  color: #fff !important;
  padding: 7px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.free-trial-btn:hover {
  opacity: 0.8 !important;
}

.free-trial-btn:hover {
  background-color: #218838;
}

/* Mobile Layout */
.mobile-table {
  display: none;
}

.mobile-table .pricing-plan-card {
  border: 1px solid #ddd;
  margin-bottom: 20px;
  padding: 20px;
  background-color: white;
}

.plan-header {
  text-align: center;
  margin-bottom: 15px;
}

.features-list {
  list-style: none;
  padding: 0;
}

.features-list li {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.features-list li:last-child {
  border-bottom: none;
}

.check-icon {
  color: green;
  font-size: 1.2em;
}

.dash-icon {
  color: #ddd;
  font-size: 1.2em;
}

/* Responsive Design */
@media (max-width: 768px) {
  .desktop-table {
    display: none;
  }

  .mobile-table {
    display: block;
  }
}

.price-business-wrapper h1 {
    font-weight: 700;
    font-size: 35px;
    color: #67BD95;
    margin: 100px 0 10px;
}

.price-business-wrapper p {
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    margin-bottom: 30px;
}

.quote-btn {
  background-color: #122034 !important;
  border: 2px solid #122034 !important;
  color: #fff !important;
  padding: 7px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.quote-btn:hover {
    background-color: #152842 !important;
}

.price-quote-wrapper{
    margin: 50px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 308px;
    background-color: #6BC091;
}

.price-quote-wrapper h1 {
    font-weight: 700;
    font-size: 35px;
    color: #E1FFF1;
    margin-bottom: 10px;
}

.price-quote-wrapper p {
    font-size: 20px;
    color: #FFFFFF;
    font-weight: 400;
    margin-bottom: 30px;
}

@media screen and (max-width: 959px) {
  .price-quote-wrapper {
    height: 250px;
  }

  .price-quote-wrapper h1 {
    font-size: 1.5rem;
  }

  .price-quote-wrapper p {
    font-size: 1rem;
  }
}
</style>

